import * as React from 'react';
import { TopToolbar, useListContext, List, TextField, DateField, ReferenceField, EditButton, Pagination } from 'react-admin';
import { Card, CardActions, CardContent, CardHeader, Avatar, Grid } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import { Button, Toolbar } from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { getTsBuildInfoEmitOutputFilePath } from 'typescript';
import parse, { attributesToProps } from 'html-react-parser';
import Box from '@material-ui/core/Box';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Moment from 'moment';
import SportsIcon from '@material-ui/icons/Sports';
import DateRangeIcon from '@material-ui/icons/DateRange';

import CallIcon from '@material-ui/icons/Call';
import './ContactUs.css';

//import PostPagination from './PostPagination';

const cardStyle = {
    width: 300,
    minHeight: 300,
    margin: '0.5em',
    display: 'inline-block',
    verticalAlign: 'top'
};


const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            width: '500',
            //margin:'0 auto',

        },
        paper: {
            padding: theme.spacing(1),
            margin: 10,
            // maxWidth: 1000,
            // width: '100%',
            backgroundColor: '#F7F7F7',
            // display: 'flex',
            // justifyContent:'center'
        },
        image: {
            //width: 300,
            //height: 300,
            // margin: '0 auto',
        },
        img: {
            margin: 'auto',
            display: 'block',
            maxWidth: '100%',
            maxHeight: '100%',
        },

        playlistContainer: {
            backgroundColor: "lightgrey",
            position: "absolute",
            top: "0",
            bottom: "0",
            right: "0",
            left: "0",
            overflow: "auto",
            [theme.breakpoints.down("sm")]: {
                position: "relative"
            }
        }
    }),
);

const options = {
    replace: domNode =>
    {
        if (domNode.attribs && domNode.name === 'main')
        {
            const props = attributesToProps(domNode.attribs);
            return <div {...props} />;
        }
    }
};

const ListActions = (props) => (
    <TopToolbar>

    </TopToolbar>
);


const MediaData = () =>
{
    const classes = useStyles();
    const { ids, data, basePath } = useListContext();

   

    return (

        <div className={classes.root}>


            {ids.map(id => (

                // data.map(id =>
                <Paper className={classes.paper} key={data[id].id}>
                
                 {/* width:100%;height:100%;overflow: auto; */}
                <div className={'taggbox-container'} style={{width: 100 +'%', height: 100 +'%', overflow: 'auto' }}>
                    <div className={'taggbox-socialwall'} data-wall-id="80471" view-url="https://widget.taggbox.com/80471"></div>
                    <script src="https://widget.taggbox.com/embed.min.js" type="text/javascript">
                        </script>
                        </div>

                </Paper>
                //)}
            ))}

        </div>
    );
};

export const Media = (props) => (
    <List title="All comments" {...props} pagination={false} actions={<ListActions />}>
        <MediaData id='SS1' />
    </List>
);